module.exports = __webpack_public_path__ + "img/productPage2.9d8d7ef1.png";